"use client";
import * as prismic from "@prismicio/client";
import { Heading } from "@/components/Heading";
import { useEffect, useState } from "react";
import Image from "next/image";

export default function PageOpener({ slice }) {
  const titleColour = slice.primary.title_colour;
  const titleShadow = slice.primary.title_shadow;
  const bgColour = slice.primary.background_color;
  const imageAlign = slice.primary.image_align;
  const size = slice.primary.section_size;
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const newScale = 1 + scrollY * 0.0005; // Adjust the zoom factor as needed
      setScale(newScale);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const heightClass =
    size === "large"
      ? "h-[310px] md:h-[810px]"
      : size === "medium"
        ? "h-[310px] md:h-[610px]"
        : "h-[310px]";

  return (
    <>
      <link rel="preload" href={slice.primary.image.url} as="image" />

      <div
        className={`relative w-screen ${heightClass} -mt-[89px] overflow-hidden flex items-center justify-center`}
        style={{ backgroundColor: bgColour }}
      >
        <Image
          src={slice.primary.image.url}
          alt={slice.primary.image.alt}
          sizes="(max-width: 600px) 90vw, (max-width: 1200px) 60vw, 50vw"
          fill
          style={{
            objectFit: "cover",
            objectPosition: `${imageAlign}`,
            transform: `scale(${scale})`,
          }}
          loading="eager"
        />
        <div
          className="relative left-0 right-0 mx-auto z-10 w-full max-w-2xl text-center items-center"
          style={{
            color: titleColour,
            textShadow: titleShadow ? "2px 1px 4px #0000002e" : "none",
          }}
        >
          <Heading
            as="h1"
            size="5xl"
            className={`mb-7 mt-12 first:mt-0 last:mb-0`}
          >
            {prismic.asText(slice.primary.title)}
          </Heading>
        </div>
      </div>
    </>
  );
}
